/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartPie85S = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2C9.4 2 7 3 5.1 4.8c-.7.6-1.3 1.4-1.8 2.2C2.5 8.5 2 10.2 2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2zm-1 2.1v5.4L7.2 5.6c1.1-.8 2.4-1.4 3.8-1.5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgChartPie85S as ChartPie85S };
